import React from "react";
import styled, { css } from "styled-components";
import DonateForm from "./DonateForm";
import Button from "./Button";


const Support = ({ inline = undefined, theme = undefined }) => (
  <StyledSupport>
    <h2>Reporting of this type is rare, expensive, and urgently needed.</h2>
    <div>
      <p>The Outlaw Ocean Project is a non-profit organization solely dedicated to producing these stories, which we distribute globally for free. Please consider supporting the work with a financial contribution to the non-profit.</p>
      <div>
        <DonateForm theme={theme === "dark" ? "light" : "light"} />
        {/*<Button href="https://theoutlawocean.substack.com/subscribe" target="_blank" rel="noopener noreferrer">Subscribe</Button>*/}
      </div>
      {/*<small>Or <a href="https://theoutlawocean.substack.com/subscribe" target="_blank" rel="noopener noreferrer">subscribe</a> to our newsletter.</small>*/}
    </div>
  </StyledSupport>
);
export default Support;


const StyledSupport = styled.aside`
  position: relative;
  z-index: 0;
  margin: 0 auto;
  max-width: var(--max-width-inner);
  h2 {
    font-family: var(--font-heading);
    font-weight: 700;
    font-size: 1.25em;
    line-height: 1.4;
    margin: 0;
  }
  p {
    margin: 1em 0 1.5em;
    max-width: 36em;
  }
  @media ( min-width: 48em ) {
    > div {
      display: grid;
      grid-template: auto / 2fr auto;
      gap: 4em;
      align-items: center;
      justify-content: space-between;
      > div {
        display: grid;
        gap: 0.5em;
      }
    }
    h2 {
      font-size: 1.625em;
    }
    p {
      font-size: 1.125em;
      margin: 1em 0;
    }
  }
`;